const project_list = [
    {
        title: "quick_chess",
        description: "A multiplayer chess app I developed with some classmates, using the MERN stack + Socket.io for real-time communication. Currently developing a new version with my own take on the frontend.",
        imageLink: "https://i.ibb.co/26PRbQb/Screenshot-2024-01-22-at-15-59-28.png",
        stack: ["Socket.io", "React.js", "MongoDB", "Node.js", "Express.js", "Tailwind CSS"],
        github: "https://i.ibb.co/26PRbQb/Screenshot-2024-01-22-at-15-59-28.png"
    },
    {
        title: "wallstarr.github.io - This portfolio website!",
        description:"You're on it right now! Super simple to maintain for adding/removing projects and fully responsive. I utilized React.js to create reuseable components and TailwindCSS for styling. Automatically deployed using GitHub Actions",
        imageLink: "https://i.ibb.co/4tb3S9k/Screen-Shot-2021-05-26-at-21-22-05.png",
        stack: ["React.js", "TailwindCSS", "Github Actions"],
        github: "https://github.com/wallstarr/wallstarr.github.io"
    },
    {
        title: "BedBot - Web scraping discord bot for bedwars",
        description: "A Discord bot that my friend and I built for us and our friends to quickly retrieve video game statistics for Hypixel BedWars (a popular Minecraft server gamemode we bonded over during COVID). We utilized Beautiful Soup 4 to webscrape and Discord.py to interact with the Discord API.",
        imageLink: "https://i.ibb.co/6chLqWD/Screen-Shot-2021-05-23-at-18-14-44.png",
        stack: ["Python 3", "Discord.py", "bs4"],
        github: "https://github.com/wallstarr/bedbot"
    },
    {
        title: "Taur - Nearby restaurant finding iOS App",
        description: "Why can't you find nearby restaurants at the push of a single button? Well now you can, with this simple but elegeant res-Taur-ant finding iOS app that locates nearby establishments using CoreLocation and ZomatoAPI.",
        imageLink: "https://i.ibb.co/djCFCPg/Screen-Shot-2021-05-26-at-22-15-26.png",
        stack: ["Swift 5", "XCode", "UIKit", "CoreLocation"],
        github: "https://github.com/wallstarr/taur"
    },
    {
        title: "Sudoku Solving Java App",
        description: "A simple and intuitive desktop app capable of solving any Sudoku problem! I learned about this Sudoku solving backtracking algorithms in my introductory programming course, and I wanted to apply what I learned by making this app!",
        imageLink: "https://i.ibb.co/v1sCn8x/Screen-Shot-2021-05-26-at-23-25-12.png",
        stack: ["Java 8", "JavaFX"],
        github: "https://github.com/wallstarr/sudokusolver"
    },
    {
        title: "StatTrak - NBA Stat Tracking Desktop App",
        description: "NBA statistics Desktop JavaFX app, complete with a comparison tool and persistence for favorited players. The app utilizes the BallDontLie API to retrieve player stats.",
        imageLink: "https://i.ibb.co/PZb1Ypj/Screen-Shot-2021-05-26-at-23-38-08.png",
        stack: ["Java 8", "JavaFX", "Gson"],
        github: "https://github.com/wallstarr/stattrak"
    }
]

export default project_list